import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnKI: CultureInfo = {
  name: 'en-KI',
  displayName: 'English (Kiribati)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-KI',
  parent: CultureInfoEn
};
